import { initializeApp } from 'firebase/app'
import { getAnalytics, isSupported } from 'firebase/analytics'

// Firebase web app config for the prod project (sual-3). These values are
// public identifiers, not secrets — access is governed by Firebase rules.
const firebaseConfig = {
  apiKey: 'AIzaSyB3Hf8RMERSH0PxGh9NsuA8nrZvzDc9Ycc',
  authDomain: 'sual-3.firebaseapp.com',
  databaseURL: 'https://sual-3.firebaseio.com',
  projectId: 'sual-3',
  storageBucket: 'sual-3.firebasestorage.app',
  messagingSenderId: '579948651539',
  appId: '1:579948651539:web:41b9e96d5ef579e1998be6',
  measurementId: 'G-PZEQY5HT3L',
}

export const app = initializeApp(firebaseConfig)

// Analytics needs browser APIs (cookies, IndexedDB) that aren't always available.
isSupported().then((supported) => {
  if (supported) getAnalytics(app)
})
